/** @format */

import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import { css } from 'styled-components/macro'; //eslint-disable-line
import background from '../../images/main/BG.png';
import Header, { NavLink, NavLinks, PrimaryLink, LogoLink, NavToggle, DesktopNavLinks } from '../headers/light.js';

const StyledHeader = styled(Header)`
	${tw`pt-8 z-10 `}
	${DesktopNavLinks} ${NavLink}, ${LogoLink} {
		${tw`text-black `}/* hover:border-gray-300 hover:text-gray-300 */
	}
	${NavToggle}.closed {
		${tw`text-gray-100 hover:text-primary-500`}
	}
`;
const Container = styled.div`
	${tw`relative bg-center bg-cover bg-no-repeat  h-screen w-screen `}
	background-image: url('${background}');
	background-position: 85%;
	@media (max-width: 600px) {
		background-position: center;
	}
`;

/* const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-500 opacity-25`; */

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto z-10`;
const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-16 lg:mt-0 lg:pl-8`;

const Heading = styled.h1`
	${tw`text-4xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl text-gray-100 leading-none`}
	span {
		${tw`inline-block mt-2 font-bold text-main `}
	}
`;

export const PrimaryAction = tw.button`px-5 py-3 mt-6 text-sm sm:text-sm sm:mt-5 sm:px-6 sm:py-3 bg-btnprimary text-white font-medium rounded-lg shadow focus:shadow-outline`;

const BackgroundAsImage = () => {
	const navLinks = [
		<NavLinks key={1}>
			<NavLink href="/#">Credit Repair</NavLink>
			<NavLink href="/#">How It Works</NavLink>
			<NavLink href="/#">Who We Are</NavLink>
			<NavLink href="/#">Pricing</NavLink>
			<NavLinks key={2}>
				<PrimaryLink href="/#">Login</PrimaryLink>
			</NavLinks>
		</NavLinks>,
	];

	return (
		<Container>
			<HeroContainer>
				<StyledHeader links={navLinks} />
				<TwoColumn>
					<LeftColumn>
						<Heading>
							<span>Improve your </span>
							<span>Credit Score.</span>
							<br />
							<span>Live Better.</span>
							<br />
						</Heading>
						<p className="hero-para">
							Stop paying high fess on a mortgage, car financing or credit cards. See how much you can
							save today
						</p>
						<a href="#form">
							<PrimaryAction>Get a Free Credit Audit</PrimaryAction>
						</a>
					</LeftColumn>
					<RightColumn></RightColumn>
				</TwoColumn>
			</HeroContainer>
		</Container>
	);
};

export default BackgroundAsImage;
